<template>
  <div></div>
</template>
<script>

export default {
  data () {
    return {
    }
  },
  methods: {
    prepareSearchWithAdvancedQuery: function (queryData) {
      let queryParams = {}

      if (queryData.date !== null && queryData.date.to !== null && queryData.date.from !== null) {
        queryParams.daterange = queryData.date.from + '-' + queryData.date.to
      }

      if (queryData.document_type !== 'science') {
        switch (queryData.document_type) {
          case 'patents':
            queryParams.typeSearched = 1
            break
          case 'company':
            queryParams.typeSearched = 3
            break
          case 'news':
            queryParams.typeSearched = 4
            break
          case 'aichat':
            queryParams.typeSearched = 5
            break
        }
      }

      if (queryData.nb_documents !== 120) {
        queryParams.nbResults = queryData.nb_documents
      }

      if (queryData.sources.length > 0 && !(queryData.sources.length === 1 && queryData.sources[0] === 'default')) {
        queryParams._sources = queryData.sources.join(';')
      }

      if (typeof this.suggestionsFilter !== 'undefined' && queryData.suggestions_filter !== this.suggestionsFilter[0]) {
        queryParams.unlimitedSuggestions = true
      }

      if (Array.isArray(queryData.countries) === true && queryData.countries != null && queryData.countries.length !== 0) {
        queryParams._countries = queryData.countries.join(',')
      }

      return queryParams
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Mixins/Search.vue